// source: dbPermission.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.common.model.DbPermission', null, global);
goog.exportSymbol('proto.common.model.DbPermission.Api', null, global);
goog.exportSymbol('proto.common.model.DbPermissionList', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.DbPermission = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.DbPermission.repeatedFields_, null);
};
goog.inherits(proto.common.model.DbPermission, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.DbPermission.displayName = 'proto.common.model.DbPermission';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.DbPermission.Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.DbPermission.Api.repeatedFields_, null);
};
goog.inherits(proto.common.model.DbPermission.Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.DbPermission.Api.displayName = 'proto.common.model.DbPermission.Api';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.DbPermissionList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.DbPermissionList.repeatedFields_, null);
};
goog.inherits(proto.common.model.DbPermissionList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.DbPermissionList.displayName = 'proto.common.model.DbPermissionList';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.DbPermission.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.DbPermission.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.DbPermission.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.DbPermission} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbPermission.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
apisList: jspb.Message.toObjectList(msg.getApisList(),
    proto.common.model.DbPermission.Api.toObject, includeInstance),
deleted: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.DbPermission}
 */
proto.common.model.DbPermission.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.DbPermission;
  return proto.common.model.DbPermission.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.DbPermission} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.DbPermission}
 */
proto.common.model.DbPermission.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = new proto.common.model.DbPermission.Api;
      reader.readMessage(value,proto.common.model.DbPermission.Api.deserializeBinaryFromReader);
      msg.addApis(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.DbPermission.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.DbPermission.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.DbPermission} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbPermission.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApisList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.common.model.DbPermission.Api.serializeBinaryToWriter
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.DbPermission.Api.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.DbPermission.Api.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.DbPermission.Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.DbPermission.Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbPermission.Api.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
alias: jspb.Message.getFieldWithDefault(msg, 2, ""),
exchange: jspb.Message.getFieldWithDefault(msg, 3, 0),
symbolsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
uidsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
apitype: jspb.Message.getFieldWithDefault(msg, 6, ""),
ban: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.DbPermission.Api}
 */
proto.common.model.DbPermission.Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.DbPermission.Api;
  return proto.common.model.DbPermission.Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.DbPermission.Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.DbPermission.Api}
 */
proto.common.model.DbPermission.Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlias(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExchange(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addSymbols(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addUids(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setApitype(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.DbPermission.Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.DbPermission.Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.DbPermission.Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbPermission.Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAlias();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExchange();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getUidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getApitype();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBan();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.common.model.DbPermission.Api.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string alias = 2;
 * @return {string}
 */
proto.common.model.DbPermission.Api.prototype.getAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.setAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 exchange = 3;
 * @return {number}
 */
proto.common.model.DbPermission.Api.prototype.getExchange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.setExchange = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated string symbols = 4;
 * @return {!Array<string>}
 */
proto.common.model.DbPermission.Api.prototype.getSymbolsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.setSymbolsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.addSymbols = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};


/**
 * repeated string uids = 5;
 * @return {!Array<string>}
 */
proto.common.model.DbPermission.Api.prototype.getUidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.setUidsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.addUids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.clearUidsList = function() {
  return this.setUidsList([]);
};


/**
 * optional string apiType = 6;
 * @return {string}
 */
proto.common.model.DbPermission.Api.prototype.getApitype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.setApitype = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool ban = 7;
 * @return {boolean}
 */
proto.common.model.DbPermission.Api.prototype.getBan = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.DbPermission.Api} returns this
 */
proto.common.model.DbPermission.Api.prototype.setBan = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.common.model.DbPermission.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbPermission} returns this
 */
proto.common.model.DbPermission.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Api apis = 2;
 * @return {!Array<!proto.common.model.DbPermission.Api>}
 */
proto.common.model.DbPermission.prototype.getApisList = function() {
  return /** @type{!Array<!proto.common.model.DbPermission.Api>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.model.DbPermission.Api, 2));
};


/**
 * @param {!Array<!proto.common.model.DbPermission.Api>} value
 * @return {!proto.common.model.DbPermission} returns this
*/
proto.common.model.DbPermission.prototype.setApisList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.model.DbPermission.Api=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbPermission.Api}
 */
proto.common.model.DbPermission.prototype.addApis = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.model.DbPermission.Api, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbPermission} returns this
 */
proto.common.model.DbPermission.prototype.clearApisList = function() {
  return this.setApisList([]);
};


/**
 * optional bool deleted = 3;
 * @return {boolean}
 */
proto.common.model.DbPermission.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.DbPermission} returns this
 */
proto.common.model.DbPermission.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.DbPermissionList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.DbPermissionList.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.DbPermissionList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.DbPermissionList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbPermissionList.toObject = function(includeInstance, msg) {
  var f, obj = {
permissionsList: jspb.Message.toObjectList(msg.getPermissionsList(),
    proto.common.model.DbPermission.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.DbPermissionList}
 */
proto.common.model.DbPermissionList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.DbPermissionList;
  return proto.common.model.DbPermissionList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.DbPermissionList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.DbPermissionList}
 */
proto.common.model.DbPermissionList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.model.DbPermission;
      reader.readMessage(value,proto.common.model.DbPermission.deserializeBinaryFromReader);
      msg.addPermissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.DbPermissionList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.DbPermissionList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.DbPermissionList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbPermissionList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.common.model.DbPermission.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DbPermission permissions = 1;
 * @return {!Array<!proto.common.model.DbPermission>}
 */
proto.common.model.DbPermissionList.prototype.getPermissionsList = function() {
  return /** @type{!Array<!proto.common.model.DbPermission>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.model.DbPermission, 1));
};


/**
 * @param {!Array<!proto.common.model.DbPermission>} value
 * @return {!proto.common.model.DbPermissionList} returns this
*/
proto.common.model.DbPermissionList.prototype.setPermissionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.model.DbPermission=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbPermission}
 */
proto.common.model.DbPermissionList.prototype.addPermissions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.model.DbPermission, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbPermissionList} returns this
 */
proto.common.model.DbPermissionList.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};


goog.object.extend(exports, proto.common.model);
